import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../supabase';

function Banner() {
    const navigate = useNavigate();
    const [banner, setBanner] = useState(null);
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        const fetchBanner = async () => {
            const { data } = await supabase
                .from('banners')
                .select('*')
                .eq('enabled', true)
                .maybeSingle(); // au lieu de .single()
            if (data) setBanner(data);
        };
        fetchBanner();
    }, []);

    if (!banner || dismissed) return null;

    return (
        <div style={{
            width: '100%',
            background: '#0e1013',
            color: '#f4efe4',
            padding: '9px 16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
            fontFamily: 'Helvetica Neue, Arial, sans-serif',
            fontSize: '12px',
            fontWeight: 500,
            position: 'relative',
            flexWrap: 'wrap',
            textAlign: 'center',
        }}>
            <span>{banner.message}</span>
            {banner.link_url && (
                <span
                    onClick={() => navigate(banner.link_url)}
                    className="wlink"
                    style={{
                        fontWeight: 700,
                        whiteSpace: 'nowrap',
                    }}
                >
                    {banner.link_text} →
                </span>
            )}
            <button
                onClick={() => setDismissed(true)}
                className="wlink"
                style={{
                    position: 'absolute',
                    right: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    color: '#f4efe4',
                    opacity: 0.7,
                    cursor: 'pointer',
                    fontSize: '13px',
                    fontWeight: 700,
                    padding: '4px',
                }}
            >
                ✕
            </button>
        </div>
    );
}

export default Banner;